<template>
  <v-footer class="d-flex flex-column pa-0">
    <!-- Newsletter & Social-->
    <v-container
      v-if="footerHasSocialMedia && footerHasNewsletter"
      fluid
      :style="{ height: footerHeight + 'px' }"
      class="pa-0 footerbar1 py-0"
    >
      <v-container class="pa-0 fill-height">
        <v-row class="d-flex justify-center py-0">
          <v-col cols="12" sm="12" md="12" lg="12" xl="9" xxl="7">
            <v-container class="pa-0">
              <v-row class="justify-space-between">
                <v-col
                  cols="12"
                  sm="4"
                  md="5"
                  lg="5"
                  xl="5"
                  class="order-last order-sm-first py-0"
                >
                  <FooterSocialmedia />
                </v-col>
                <v-col
                  cols="12"
                  sm="8"
                  md="7"
                  lg="6"
                  xl="5 "
                  class="order-first order-sm-last py-0"
                >
                  <FooterNewsletter />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <!-- Social only-->
    <v-container
      v-if="footerHasSocialMedia && !footerHasNewsletter"
      fluid
      class="pa-0 footerbar1"
      :style="{ height: '70px' }"
    >
      <v-container class="pa-0 fill-height">
        <v-row class="pa-0 fill-height">
          <v-col cols="12" class="pa-0">
            <FooterSocialmedia />
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <!-- Newsletter only-->
    <v-container
      v-if="!footerHasSocialMedia && footerHasNewsletter"
      fluid
      class="pa-0 footerbar1"
      :style="{ height: '90px' }"
    >
      <v-container class="pa-0 fill-height">
        <v-row class="d-flex justify-center">
          <v-col cols="12" sm="12" md="12" lg="12" xl="9" xxl="7">
            <v-container class="pa-0">
              <v-row class="pa-0 fill-height" justify="end">
                <v-col cols="12" sm="12" md="8" lg="7" xl="5" class="pa-0">
                  <FooterNewsletter />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <v-container class="py-0 footerbar2 d-flex d-sm-none">
      <v-container class="footerbarbetween py-0"> </v-container>
    </v-container>

    <v-container fluid class="footerlinks d-flex align-center pa-0">
      <v-container class="fill-height"> <FooterLinks /> </v-container>
    </v-container>

    <v-container fluid class="pa-0 footerCopy">
      <v-container :justify="getJustifyCopyright">
        <div class="d-flex" :class="getJustifyCopyright">
          <strong v-text="siteSettings.FooterCopyright" />
        </div>
      </v-container>
    </v-container>
  </v-footer>
</template>

<script setup>
import FooterSocialmedia from "@/components/Footer/footerSocialmedia.vue";
import FooterNewsletter from "@/components/Footer/footerNewsletter.vue";
import FooterLinks from "@/components/Footer/footerLinks.vue";
import { useSiteSettingsStore } from "../../store/siteSettings";
const { $helpers } = useNuxtApp()
const siteSettings = useSiteSettingsStore();
let footerHasNewsletter =
  $helpers.isset(siteSettings["FooterNewsLetterTitle"]) &&
  siteSettings["FooterNewsLetterTitle"] != "";
let footerHasSocialMedia =
  ($helpers.isset(siteSettings["FooterIconFacebookUrl"]) &&
    siteSettings["FooterIconFacebookUrl"] != "") ||
  ($helpers.isset(siteSettings["FooterIconLinkedinUrl"]) &&
    siteSettings["FooterIconLinkedinUrl"] != "") ||
  ($helpers.isset(siteSettings["FooterIconYoutubeUrl"]) &&
    siteSettings["FooterIconYoutubeUrl"] != "") ||
  ($helpers.isset(siteSettings["FooterIconWhatsapp"]) &&
    siteSettings["FooterIconWhatsapp"] != "");

const footerHeight = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 200;
    case "sm":
      return 95;
    case "md":
      return 95;
    case "lg":
      return 95;
    case "xl":
      return 95;
    case "xxl":
      return 95;      
    default:
      return 95;
  }
});

const getJustifyCopyright = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return "justify-center";
    case "sm":
      return "justify-start";
    case "md":
      return "justify-start";
    case "lg":
      return "justify-start";
    case "xl":
      return "justify-start";
    case "xxl":
      return "justify-start";      
    default:
      return "justify-start";
  }
});
</script>

